export default function SearchIcon2 (){
    return <i className="fa-solid fa-magnifying-glass fa-xs "></i>
}